/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const LayerIcon = /*#__PURE__*/ createSvgIcon(
  'LayerIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.07 1.444l8.072 3.93-2.65 1.29 2.64 1.356-2.646 1.245 2.613 1.406-8.029 3.885L.046 10.65l2.59-1.394L.018 8.024l2.618-1.367L0 5.375l8.07-3.93zM4.108 6.263a.501.501 0 00-.251-.125l-1.57-.764L8.07 2.557l5.786 2.817-1.696.826a.52.52 0 00-.018.008L8.071 8.273l-3.964-2.01zm-.356.94l4.32 2.191 4.302-2.181 1.495.768-1.701.8a.551.551 0 00-.024.012L8.07 10.856l-3.964-2.01a.501.501 0 00-.258-.125l-1.58-.744 1.482-.774zm.004 2.586l-1.515.815 5.832 2.84 5.829-2.82-1.533-.825-4.297 2.178-4.316-2.188z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10 2.453l10 4.424-3.354 1.482 3.343 1.559-3.35 1.432 3.313 1.62L10 17.342l-9.949-4.4 3.285-1.604L.02 9.921l3.316-1.57L0 6.877l10-4.424zM4.875 7.955a.495.495 0 00-.27-.122L2.44 6.877 10 3.532l7.56 3.345-2.305 1.018a.481.481 0 00-.008.004L10 10.314 4.875 7.955zm-.35.925L10 11.4l5.452-2.51 2.12.989-2.307.985a.49.49 0 00-.029.013L10 13.287l-5.125-2.359a.495.495 0 00-.277-.122l-2.177-.93 2.103-.996zm.003 2.974L2.389 12.9l7.612 3.366 7.607-3.343-2.16-1.056L10 14.374l-5.472-2.52z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 2.45l12.196 5.612-4.194 1.928 4.184 2.03-4.191 1.863 4.155 2.111L12 21.55-.149 15.96l4.12-2.092-4.15-1.845 4.15-2.045-4.169-1.916L12 2.449zM5.52 9.591a.501.501 0 00-.306-.143L2.196 8.06 12 3.55l9.803 4.511-3.18 1.462L12 12.694 5.52 9.592zm-.381.926l6.86 3.285 6.831-3.27 2.984 1.447-3.192 1.418L12 16.57l-6.48-3.103a.502.502 0 00-.312-.144l-3.03-1.347 2.961-1.458zm.004 3.877L12 17.679l6.825-3.269 3.024 1.537-9.848 4.502-9.853-4.533 2.995-1.521z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default LayerIcon;
